// extracted by mini-css-extract-plugin
export default {"fade":"styles_fade__lGXcI","fadeOut":"styles_fadeOut__1Jly+","fadeIn":"styles_fadeIn__RMRor"};